import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "question-details-con" }
const _hoisted_2 = { class: "header-index" }
const _hoisted_3 = { class: "bottom-btn" }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_detail = _resolveComponent("question-detail")!
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.currentIndex + 1) + "题/" + _toDisplayString(_ctx.questionIds.length) + "题", 1),
    (_ctx.currentQuestion)
      ? (_openBlock(), _createBlock(_component_question_detail, {
          key: 0,
          source: "favorite_notebook",
          showKnowledgePoint: true,
          questionData: _ctx.currentQuestion
        }, null, 8, ["questionData"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevQuestion && _ctx.prevQuestion(...args))),
        class: _normalizeClass({'disabled': _ctx.currentIndex === 0})
      }, "上一题", 2),
      _createElementVNode("a", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextQuestion && _ctx.nextQuestion(...args))),
        class: _normalizeClass({'disabled': _ctx.currentIndex === _ctx.questionIds.length - 1})
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_van_loading, { key: 0 }))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "下一题"))
      ], 2)
    ])
  ]))
}